/* ============================================================================
   tne-cursos.js — Plataforma de Cursos privada (/pages/portal-cursos)
   DistribuidorTopBioEuropa | Site institucional B2B

   Carrega a YouTube IFrame Player API, controla o modal do player e faz
   tracking de progresso por vídeo (% visto). O progresso fica em
   localStorage por simplicidade — para métricas agregadas por revendedora
   ao nível dos chefes é preciso acrescentar webhook + backend (não
   coberto neste módulo).

   Vídeo é considerado concluído a partir de 90% visto.

   Bootstrap:
     1. Detecta .tne-curso-card no DOM (sai cedo se não estivermos em
        /pages/portal-cursos com tag activa)
     2. Restaura progresso guardado (badge + barras + label do botão)
     3. Liga listeners aos cards e ao modal
     4. Lazy-loads a IFrame API só na primeira abertura do modal
   ============================================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'tne_cursos_progresso';
  var TRACKING_INTERVAL_MS = 5000;
  var COMPLETED_THRESHOLD = 90;

  var player = null;       // YT.Player instância (null antes da 1ª abertura)
  var apiLoading = false;  // se já estamos a fazer download da iframe API
  var apiReady = false;    // se YT.Player já está disponível
  var pendingPlay = null;  // {videoId, titulo} — guarda para tocar quando API ficar pronta
  var trackingInterval = null;

  /* ----------------------------------------------------------------------------
     Storage helpers
     ---------------------------------------------------------------------------- */

  function readProgress() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function writeProgress(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* noop — modo privado */ }
  }

  function saveProgress(videoId, pct) {
    if (!videoId) return;
    var data = readProgress();
    var prev = data[videoId] || 0;
    // Só sobe — se a revendedora reabrir o vídeo no início, mantém o máximo.
    data[videoId] = Math.max(prev, pct);
    writeProgress(data);
  }

  /* ----------------------------------------------------------------------------
     UI updates
     ---------------------------------------------------------------------------- */

  function updateCardProgress(card, pct) {
    if (!card) return;
    var blockId = card.id.replace('curso-', '');
    var fill = document.getElementById('progresso-' + blockId);
    var label = document.getElementById('progresso-label-' + blockId);
    var badge = document.getElementById('badge-' + blockId);
    var btn = card.querySelector('.tne-curso-card__btn');

    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = pct + '% visto';
    if (badge) {
      if (pct >= COMPLETED_THRESHOLD) {
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
    if (btn) {
      if (pct >= COMPLETED_THRESHOLD) {
        btn.textContent = 'Rever ↻';
      } else if (pct > 0) {
        btn.textContent = 'Continuar (' + pct + '%) →';
      } else {
        btn.textContent = 'Começar →';
      }
    }
  }

  function updateModalProgress(pct) {
    var fill = document.getElementById('tne-modal-progresso-fill');
    var label = document.getElementById('tne-modal-progresso-label');
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = pct + '% visto';
  }

  function updateOverallProgress() {
    var data = readProgress();
    var cards = document.querySelectorAll('.tne-curso-card');
    var total = cards.length;
    var completed = 0;

    cards.forEach(function (card) {
      var videoId = card.getAttribute('data-video-id');
      if (data[videoId] && data[videoId] >= COMPLETED_THRESHOLD) {
        completed++;
      }
    });

    var pct = total > 0 ? Math.floor((completed / total) * 100) : 0;
    var fill = document.getElementById('tne-progresso-geral-fill');
    var label = document.getElementById('tne-progresso-geral-label');
    if (fill) fill.style.width = pct + '%';
    if (label) {
      label.textContent = completed + ' de ' + total + ' cursos concluídos';
    }
  }

  function loadInitialProgress() {
    var data = readProgress();
    document.querySelectorAll('.tne-curso-card').forEach(function (card) {
      var videoId = card.getAttribute('data-video-id');
      var pct = data[videoId] || 0;
      if (pct > 0) updateCardProgress(card, pct);
    });
    updateOverallProgress();
  }

  /* ----------------------------------------------------------------------------
     YouTube IFrame API
     ---------------------------------------------------------------------------- */

  function loadYouTubeAPI() {
    if (apiReady || apiLoading) return;
    apiLoading = true;

    // Hook global esperado pela API.
    window.onYouTubeIframeAPIReady = function () {
      apiReady = true;
      if (pendingPlay) {
        var p = pendingPlay;
        pendingPlay = null;
        startPlayer(p.videoId, p.titulo);
      }
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  function startPlayer(videoId, titulo) {
    var titleEl = document.getElementById('tne-modal-titulo');
    if (titleEl) titleEl.textContent = titulo || '';

    if (player) {
      player.loadVideoById(videoId);
      return;
    }

    player = new YT.Player('tne-youtube-player', {
      videoId: videoId,
      width: '100%',
      height: '100%',
      playerVars: {
        rel: 0,
        modestbranding: 1,
        playsinline: 1
      },
      events: {
        onStateChange: onPlayerStateChange
      }
    });
  }

  function onPlayerStateChange(event) {
    if (!window.YT || !window.YT.PlayerState) return;
    if (event.data === YT.PlayerState.PLAYING) {
      startTracking();
    } else {
      stopTracking();
      // Snapshot final quando pausa/termina — capta o último 5%.
      if (event.data === YT.PlayerState.PAUSED ||
          event.data === YT.PlayerState.ENDED) {
        captureProgress();
      }
    }
  }

  function startTracking() {
    stopTracking();
    trackingInterval = setInterval(captureProgress, TRACKING_INTERVAL_MS);
  }

  function stopTracking() {
    if (trackingInterval) {
      clearInterval(trackingInterval);
      trackingInterval = null;
    }
  }

  function captureProgress() {
    if (!player || typeof player.getCurrentTime !== 'function') return;
    var current = player.getCurrentTime();
    var total = player.getDuration();
    if (!total || total <= 0) return;

    var pct = Math.min(100, Math.floor((current / total) * 100));
    var data = player.getVideoData();
    var videoId = data && data.video_id;
    if (!videoId) return;

    saveProgress(videoId, pct);
    updateModalProgress(pct);

    var card = document.querySelector(
      '.tne-curso-card[data-video-id="' + videoId + '"]'
    );
    if (card) updateCardProgress(card, pct);
    updateOverallProgress();
  }

  /* ----------------------------------------------------------------------------
     Modal control
     ---------------------------------------------------------------------------- */

  function openModal(videoId, titulo) {
    if (!videoId) return;
    var modal = document.getElementById('tne-curso-modal');
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    // Reset visual da progresso bar do modal antes de o player começar
    // a reportar — evita mostrar o estado de outro curso anterior.
    updateModalProgress(0);

    if (apiReady) {
      startPlayer(videoId, titulo);
    } else {
      pendingPlay = { videoId: videoId, titulo: titulo };
      loadYouTubeAPI();
    }
  }

  function closeModal() {
    var modal = document.getElementById('tne-curso-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';

    if (player && typeof player.pauseVideo === 'function') {
      player.pauseVideo();
    }
    stopTracking();
  }

  /* ----------------------------------------------------------------------------
     Bootstrap
     ---------------------------------------------------------------------------- */

  function init() {
    var grid = document.getElementById('tne-cursos-grid');
    if (!grid) return; // não estamos na página correcta

    loadInitialProgress();

    // Triggers (thumb + botão) — abre o modal com o vídeo correspondente.
    document.querySelectorAll('[data-tne-curso-trigger]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        var card = el.closest('.tne-curso-card');
        if (!card) return;
        var videoId = card.getAttribute('data-video-id');
        var tituloEl = card.querySelector('.tne-curso-card__titulo');
        var titulo = tituloEl ? tituloEl.textContent.trim() : '';
        openModal(videoId, titulo);
      });
    });

    // Fechar modal: botão close + clique no overlay + ESC.
    var closeBtn = document.getElementById('tne-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.querySelectorAll('[data-tne-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var modal = document.getElementById('tne-curso-modal');
        if (modal && !modal.hidden) closeModal();
      }
    });

    initFilters();
  }

  /* ----------------------------------------------------------------------------
     Filtros por categoria — mostra/esconde cards conforme data-categoria.
     Reutiliza estilos .tne-portal__filtros / .tne-filtro / .is-active.
     ---------------------------------------------------------------------------- */
  function initFilters() {
    var filtros = document.querySelector('[data-tne-cursos-filtros]');
    if (!filtros) return;

    var btns = filtros.querySelectorAll('.tne-filtro');
    var cards = document.querySelectorAll('.tne-curso-card');
    var emptyMsg = document.querySelector('[data-tne-cursos-empty]');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var alvo = btn.getAttribute('data-filtro') || 'todos';

        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var visiveis = 0;
        cards.forEach(function (card) {
          var cat = card.getAttribute('data-categoria') || 'geral';
          var match = alvo === 'todos' || cat === alvo;
          card.classList.toggle('is-filtrado-out', !match);
          if (match) visiveis++;
        });

        if (emptyMsg) emptyMsg.hidden = visiveis !== 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
